<template>
  <section
    id="about"
    class="hide-overflow"
  >
    <v-layout white>
      <v-flex
        xs12
        md6
        pa-5
      >
        <base-bubble-1
          style="transform: translate(5%, -5%)"
        />
        <base-heading class="info--text">
          About Me
        </base-heading>

        <base-text class="mb-5">
          Aloha Family, I am a Self Taught Software Developer.<br>
          I have been consistently studying and developing as much as possible for the past few years.
          I have a new found respect for my self and career, Im completely focused and determined to see my ideas manifest into reality and the effect they may have on society.
        </base-text>

        <base-subheading class="info--text">
          Skills
        </base-subheading>
        <div>
        <v-chip color="blue" x-large >Python</v-chip><v-chip color="blue">Django</v-chip>
        <v-chip color="blue">Javascript</v-chip><v-chip color="blue">Vue.js</v-chip>
        <v-chip color="blue">Node.js</v-chip><v-chip large color="blue">Ethereum</v-chip>
        <v-chip large color="blue">SQL</v-chip><v-chip large color="blue">MongoDB</v-chip>
        </div>
          <v-row align="center" justify="center">
        
    
    <!-- <v-flex>
    <v-img
      src="https://img.icons8.com/color/48/000000/python.png"
      lazy-src="https://img.icons8.com/color/48/000000/python.png" 
      aspect-ratio="1"
      class=""
      max-width="300"
      max-height="200"
    ></v-img>
       <v-img
      src="https://img.icons8.com/color/48/000000/nodejs.png"   
      lazy-src="https://img.icons8.com/color/48/000000/python.png" 
      aspect-ratio="1"
      class=""
      max-width="300"
      max-height="200"
    ></v-img><v-icon src="https://img.icons8.com/wired/64/000000/ruby-programming-language.png" xs></v-icon>
    </v-flex> -->
  



  </v-row>
        <!-- <base-text class="mb-5">
          Lorem ipsum dolor sit amet, consecte tur adipi scin e<br>
          lit. Etiam vulputate augu e vel felis gravida porta.
        </base-text> -->
        
        <!-- <v-alert
          outlined
          color="info"
        > -->
          <!-- <v-layout
            v-for="(skill, i) in skills"
            :key="i"
            style="color: #69A1BB;"
            wrap
          >
            <v-flex
              xs6
              text-uppercase
              v-text="skill.name"
            />
            <v-flex
              xs6
              text-xs-right
              v-text="`${skill.value}%`"
            />
            <v-progress-linear
              :value="skill.value"
              color="info"
              height="8"
            />
          </v-layout> -->
        <!-- </v-alert> -->
      </v-flex>
      <v-flex
        hidden-sm-and-down
        md6
      >
        <v-img
          :src="require('@/assets/purpletshirt.jpg')"
          height="100%"
        />
      </v-flex>
    </v-layout>
  </section>
</template>

<script>
export default {
  data: () => ({
    skills: [
      {
        name: 'Web Design',
        value: 100
      },
      {
        name: 'Web Development',
        value: 75
      },
      {
        name: 'Web Support',
        value: 90
      }
    ]
  })
}
</script>
